import React from 'react';

import AppRouts from './Routes/AppRouts';

function App() {
  return (
    <div className="App min-h-screen bg-slate-50">
      {/* Aapka main entry point jo saare routing paths ko handle karega */}
      <AppRouts />
    </div>
  );
}

export default App;